export default "/images/warning.png?87b41793ead771ee6eeea3be311277d4";